import React from 'react';
import {PartialNullable} from '../../../../../types/types';
import {Contractor} from '../../../../api/contractor-api/Contractor';
import {LabelWithDescription} from '../../../../components/Inputs/LabelWithDescription';
import {useIntl} from '../../../../hooks/use-intl';

type Props = {
  contractor: PartialNullable<Contractor>;
};

export const EntrepreneurInfo: React.FC<Props> = ({contractor}) => {
  const intl = useIntl();
  const renderPaymentRequisitesItem = (title: string, value?: string | number | null) => {
    if (!value) {
      return null;
    }

    return (
      <div className={'mb-3'}>
        <LabelWithDescription className={{label: 'mb-0'}} label={intl.formatMessage({id: title})} />
        <div>{value}</div>
      </div>
    );
  };

  return (
    <div>
      <div className={'d-flex flex-wrap'}>
        <div className={'mr-8'}>{renderPaymentRequisitesItem('LAST_NAME', contractor?.entrepreneur_name_last)}</div>
        <div className={'mr-8'}>{renderPaymentRequisitesItem('FIRST_NAME', contractor?.entrepreneur_name_first)}</div>
        <div className={'mr-8'}>{renderPaymentRequisitesItem('MIDDLE_NAME', contractor?.entrepreneur_name_middle)}</div>
      </div>

      {renderPaymentRequisitesItem('JURISDICTION_ENTREPRENEUR', contractor?.jurisdiction)}
      {renderPaymentRequisitesItem('TAX_PAYER_NUMBER', contractor?.entrepreneur_inn)}
      {renderPaymentRequisitesItem('OGRNIP', contractor?.entrepreneur_ogrnip)}
    </div>
  );
};
